import React, {Component} from 'react'
import Modal from "../Modal";
import MozillaModalForm from "../../forms/file/ModalMozillaForm";
import PropTypes from "prop-types";

class MozillaModal extends Component {
    render() {
        const {id, finishCallback} = this.props;

        return <Modal id={id}>
            {(closeModal) => (
                <MozillaModalForm closeModal={closeModal} finishCallback={finishCallback} />
            )}
        </Modal>
    }
}

MozillaModal.propTypes = {
    id: PropTypes.string.isRequired,
    finishCallback: PropTypes.func,
};

MozillaModal.defaultProps = {
    finishCallback: () => {},
};

export default MozillaModal